<!-- 教师备授课活跃排行Top5 -->
<template>
    <div class="active-school-rank">
        <div class="active-school-rank-top">
            <div class="title">综评排行榜</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="active-school-rank-content">
            <table style="width: 100%;text-align: left;">
                <thead>
                    <tr class="table-head">
                        <th style="width: 40%;">学校排名</th>
                        <th style="width: 20%;">评价次数</th>
                        <th style="width: 20%;">点评教师数</th>
                        <th style="width: 20%;">被评学生数</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(school, index) in schoolList" :key="school.schoolId" class="table-content">
                        <td class="rank" :class="index == 0 ? 'one' : index == 1 ? 'two' : index == 2 ? 'three' : ''">
                            {{ `NO.${index + 1}&#32${school.schoolName}` }}</td>
                        <td>{{ school.evaluationCount }}</td>
                        <td>{{ school.TeaEvaluationCount }}</td>
                        <td>{{ school.StuEvaluationCount }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
export default {
    name: 'comprehensive-rank',
    components: {
    },
    props: {
        //请求参数
        params: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            //是否选中授课
            isActiveLectures: false,
            rankList: [],
            schoolList: [
                {
                    schoolName: "月华路小学",
                    schoolId: '1',
                    evaluationCount: 23764,
                    TeaEvaluationCount: 12501,
                    StuEvaluationCount: 2012,
                },
                {
                    schoolName: "南京路小学",
                    schoolId: '2',
                    StuEvaluationCount: 1980,
                    TeaEvaluationCount: 12305,
                    evaluationCount: 22637,
                },
                {
                    schoolName: "兴圆小学",
                    schoolId: '3',
                    StuEvaluationCount: 1856,
                    TeaEvaluationCount: 12065,
                    evaluationCount: 21365,
                },
                {
                    schoolName: "实验小学",
                    schoolId: '4',
                    StuEvaluationCount: 1651,
                    TeaEvaluationCount: 10265,
                    evaluationCount: 12235,
                },
                {
                    schoolName: "振新小学",
                    schoolId: '5',
                    StuEvaluationCount: 1520,
                    TeaEvaluationCount: 9584,
                    evaluationCount: 10675,
                },
            ],
        }
    },
    methods: {

        /**
         * @name 跳转更多
         */
        goMore() {

        },
    },
    mounted() {

    },
}
</script>
  
<style lang="scss" scoped>
.active-school-rank {
    width: 100%;
    height: 305px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;

    // background: rgba(6,17,52,0.8);
    .active-school-rank-top {
        position: relative;
        text-align: center;
        margin-bottom: 20px;

        .title {
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }

        .title-bg {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .active-school-rank-content {
        height: calc(100% - 60px);
        width: 100%;

        .table-head {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #708ACC;
            line-height: 29px;
        }

        .table-content {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #6EA0D3;
            line-height: 44px;

            .rank {
                font-size: 14px;
                // font-family: DingTalk JinBuTi;
                font-weight: 400;
                color: #6EA0D3;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                height: 30px;
                padding: 2px;
                text-align: left;
                background-size: 100% 100%;
                background: url('../../../assets/images/sydataboard/four.png') no-repeat;
            }

            .one {
                background: url('../../../assets/images/sydataboard/one.png') no-repeat;
                color: #FF5B74;
            }

            .two {
                background: url('../../../assets/images/sydataboard/two.png') no-repeat;
                color: #CEB151;
            }

            .three {
                background: url('../../../assets/images/sydataboard/three.png') no-repeat;
                color: #27CDE6;
            }
        }
    }

    .top-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }

    .top-right {
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }

    .left-bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }

    .right-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>